export const modifiersStyles = {
  selected: {
    backgroundColor: '#5D7C78',
    color: '#E6ECE9',
  },
};
